import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import moment from 'moment-timezone';
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import {Objects, Parts} from "../index";
import Collections from "./index";
import Search from '@material-ui/icons/Search'
import EngineerHDCard from "../Parts/EngineerHDCard";

export default class HelpDesks extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state = {
			...this.state,
			search: "",
			regions: [],
			users: [],
			field_engineers: null,
			showFinancial: false,
			showDate: false,
			help_desk_contacted_modal: false,
			filterTOS: false
		}

		try {
			if (localStorage.getItem('dateHelpdesks')) {
				this.state.filterDate = moment((localStorage.getItem('dateHelpdesks'))).format();
			} else {
				this.state.filterDate = moment(Date.now()).format();
			}
			if (localStorage.getItem('usersHelpdesks')) {
				this.state.selectedUsers = JSON.parse(localStorage.getItem('usersHelpdesks')) ?? [];
			} else {
				this.state.selectedUsers = [];
			}
			if (localStorage.getItem('regionsHelpdesks')) {
				this.state.selectedRegions = JSON.parse(localStorage.getItem('regionsHelpdesks')) ?? [];
			} else {
				this.state.selectedRegions = [];
			}
		} catch (e) {
			console.log(e, 'error')
		}
		this.state.helpdesksView = localStorage.getItem('viewHelpdesks') ?? 'day';
		moment.tz.setDefault("America/Phoenix");
	}

	componentDidMount() {
		if (typeof super.componentDidMount === "function") {
			super.componentDidMount();
		}
		this.loadHelpDeskBoard();
		this.refreshinterval = setInterval(() => {
			this.setState({key: Math.random()});
		}, 1000);
	}

	loadHelpDeskBoard = async () => {
		await this.getRegions();
		await this.getUsers();
		await this.getHelpdesks();
	}

	componentWillUnmount() {
		if (this.refreshinterval) {
			clearInterval(this.refreshinterval);
			this.refreshinterval = null;
		}
	}

	getHelpdesks = async (shouldTrack = false, skipDataGrab = false) => {
		if (!skipDataGrab) {
			let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ);
			this.read = 'GET_ALL';
			model.filter = {
				//for day or week, just provide the day that they're on to grab data (week just needs it to be within that week)
				'day': this.state.filterDate,
				'filterRegions': this.state.selectedRegions.map((region) => region.value),
				'users': this.state.selectedUsers.map((user) => user.value),
				'shouldTrack': shouldTrack,
			}
			model.search = this.state.search
			this.data = await model.submit(null, this.read);
		}
		this.data = skipDataGrab ? this.state.field_engineers : this.data.items;
		if (this.state.filterTOS !== false && moment().format('YYYY-MM-DD') === moment(this.state.filterDate).format('YYYY-MM-DD')) {
			this.data.sort((a, b) => {
				const aValue = a.engineer_stats[0]?.daily_total || 0;
				const bValue = b.engineer_stats[0]?.daily_total || 0;

				if (this.state.filterTOS === 'lowest') {
					return parseFloat(aValue) - parseFloat(bValue); // Ascending order
				} else {
					return parseFloat(bValue) - parseFloat(aValue); // Descending order
				}
			});
		} else if (this.state.filterTOS === false && skipDataGrab) {
			this.data.sort((a, b) => {
				const aValue = a.pkey;
				const bValue = b.pkey;

				return bValue - aValue; // Descending order
			});
		}
		this.setState({
			field_engineers: this.data
		});
		localStorage.setItem("dateHelpdesks", this.state.filterDate);
	}

	getRegions = async () => {
		let regionModel = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		regionModel.limit = 100;
		try {
			this.regions = await regionModel.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				//Todo maybe filter by ranking instead
				return a.name.localeCompare(b.name)
			});
			this.regions = this.regions.filter((item) => {
				return item.metro_walk_ranking !== null && item.metro_walk_ranking !== undefined
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
			console.log('error', error)
		}
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_FIELD_ENGINEERS';
		userModel.limit = 100;
		let usersPkeys = this.state.selectedUsers.map((user) => user.value);
		try {
			userModel.filter = {
				'filterRegions': this.state.selectedRegions.map((region) => region.value),
				'bookableOnly': true,
			};
			this.users = await userModel.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];
			//let selected = this.users.filter(item => usersPkeys.includes(item.pkey));what was this for?

			this.setState({
				users: this.users
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleUsers = (value) => {
		let users = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				users.splice(0, 0, value[i]);
			}
			localStorage.setItem("usersHelpdesks", JSON.stringify(value));
			this.state.selectedUsers = users;
		} else {
			localStorage.setItem("usersHelpdesks", JSON.stringify([]));
			this.state.selectedUsers = [];
		}
		//refreshing the data after passing filters
		this.getHelpdesks().then();
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		this.handleToggleModal('showDate');
		await this.getHelpdesks();
	}

	toggleClose = () => {
		this.setState({calendarAlerts: null, toggleAlerts: false})
	}

	render() {
		const {loading} = this.state;

		return (
			<div className={'box-body'}>
				<div className={"table-bar"}>
					<div className={"row"}>
						<div className={'col-4'}>
							<Parts.RegionSelectToggle
								parent={this}
								handleRegionsCallback={() => {
									this.getUsers().then(() => this.getHelpdesks(true));
								}}
								multi={true}
								noCycle={false}
							/>
						</div>
						<div className={"col-3"} style={{zIndex: 100}}>
							<Select
								key={this.state.users}
								placeholder={"User Select"}
								isMulti
								isClearable
								value={this.state.selectedUsers.map(user => {
									return (
										{value: user.value, label: user.label})
								})}
								onChange={this.handleUsers}
								options={this.state.users.map(user => {
									return (
										{value: user.pkey, label: user.name_first + " " + user.name_last})
								})}
							/>
						</div>
						<div className={'col'}>
							<div style={{zIndex: 100, marginLeft: 0}} className={"row rbc-toolbar"}>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({field_engineers: []})
									await this.getHelpdesks();
								}}>Refresh Data
								</button>
							</div>
						</div>

						{moment().format('YYYY-MM-DD') === moment(this.state.filterDate).format('YYYY-MM-DD') && <div className={"col-md"}>
							<ButtonGroup size={"md"}>
								<Button
									onClick={() => {
										this.setState({filterTOS: false}, async () => {
											this.setState({field_engineers: []})
											await this.getHelpdesks(false, true);
										})
									}}
									outline={this.state.filterTOS !== false}
									active={this.state.filterTOS === false}
								>
									No Filter
								</Button>
								<Button
									onClick={() => {
										this.setState({filterTOS: 'lowest'}, async () => {
											this.setState({field_engineers: []})
											await this.getHelpdesks(false, true);
										})
									}}
									outline={this.state.filterTOS !== 'lowest'}
									active={this.state.filterTOS === 'lowest'}
									color={'primary'}
								>
									Lowest TOS
								</Button>
								<Button
									onClick={() => {
										this.setState({filterTOS: 'highest'}, async () => {
											this.setState({field_engineers: []})
											await this.getHelpdesks(false, true);
										})
									}}
									outline={this.state.filterTOS !== 'highest'}
									active={this.state.filterTOS === 'highest'}
									color={'info'}
								>
									Highest TOS
								</Button>
							</ButtonGroup>
						</div>}
					</div>
					<div>
						<Modal
							isOpen={this.state.showDate}
							toggle={this.toggleClose}
							size={"sm"}
							backdrop={true}
							style={{display: "none"}}
						>
							<ModalBody>
								<Framework.Elements.Date
									label={"Custom Date"}
									value={this.state.filterDate}
									update={this.handleDateChange}
									open={this.state.showDate}
									clearable={false}
									cancelLabel={''}
								/>
							</ModalBody>
						</Modal>
						<div className={"row rbc-toolbar"}>
							<div>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).subtract(1, 'day').format()}, async () => {
										await this.getHelpdesks();
									})
								}}><LeftArrowIcon/></IconButton>
								<button className="rbc-today" type="button" onClick={async () => {
									this.setState({filterDate: moment(Date.now()).format()}, async () => {
										await this.getHelpdesks();
									})
								}}>Today
								</button>
								<IconButton onClick={async () => {
									this.setState({filterDate: moment(this.state.filterDate).add(1, 'day').format()}, async () => {
										await this.getHelpdesks();
									})
								}}><RightArrowIcon/></IconButton>
							</div>
							<div className={"rbc-toolbar-label"}>
								<label onClick={() => {
									this.handleToggleModal('showDate')
								}}>
									{moment(this.state.filterDate).format('dddd MMM D')}
								</label>
							</div>
						</div>
					</div>
				</div>

				<div className={'row'}>
					<div className={'col-12'}>
						{this.state.field_engineers ? this.state.field_engineers?.map((engineer) => {
							return engineer.calendars?.length !== 0 ?
								(
									<EngineerHDCard history={this.props.history} currentDay={moment(this.state.filterDate).format("YYYY-MM-DD")} engineer={engineer} refreshData={this.getHelpdesks}/>
								) : null;
						}) : <div style={{alignContent: "center", fontSize: 25}}>
							No appointments scheduled for this day
						</div>}
					</div>
				</div>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
